import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ArrowLeft } from 'lucide-vue-next'
import { useCarousel } from './useCarousel'
import type { WithClassAsProps } from './interface'
import { cn } from '@/utils/utils'
import { Button } from '@/components/ui/button'


export default /*#__PURE__*/_defineComponent({
  __name: 'CarouselPrevious',
  props: {
    class: {}
  },
  setup(__props: any) {

const props = __props

const { orientation, canScrollPrev, scrollPrev } = useCarousel()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Button), {
    disabled: !_unref(canScrollPrev),
    class: _normalizeClass(_unref(cn)(
      'touch-manipulation absolute h-8 w-8 rounded-full p-0',
      _unref(orientation) === 'horizontal'
        ? '-left-12 top-1/2 -translate-y-1/2'
        : '-top-12 left-1/2 -translate-x-1/2 rotate-90',
      props.class,
    )),
    variant: "outline",
    onClick: _unref(scrollPrev)
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _createVNode(_unref(ArrowLeft), { class: "h-4 w-4 text-current" })
      ])
    ]),
    _: 3
  }, 8, ["disabled", "class", "onClick"]))
}
}

})